// ─── FICHIER DE TRADUCTIONS FR / AR ──────────────────────────────────────────
export const translations = {
  fr: {
    // GÉNÉRAL
    app_name: 'Activiter Commercial',
    loading: 'Chargement...',
    save: 'Sauvegarder',
    cancel: 'Annuler',
    close: 'Fermer',
    edit: 'Modifier',
    delete: 'Supprimer',
    add: 'Ajouter',
    confirm: 'Confirmer',
    back: 'Retour',
    search: 'Rechercher',
    no_data: 'Aucune donnée',
    error: 'Erreur',
    success: 'Succès',
    yes: 'Oui',
    no: 'Non',
    all: 'Tous',
    total: 'Total',
    details: 'Détails',
    refresh: 'Actualiser',

    // LOGIN
    login_title: 'Connexion',
    login_subtitle: 'Gestion Commerciale Terrain',
    email: 'Email',
    password: 'Mot de passe',
    login_btn: 'Se connecter',
    login_error: 'Email ou mot de passe incorrect',
    login_loading: 'Connexion...',

    // DASHBOARD MANAGER
    dashboard_manager: 'Dashboard Manager',
    hello: 'Bonjour',
    visites_total: 'Visites totales',
    visites_today: "Visites aujourd'hui",
    commerciaux: 'Commerciaux',
    actions_retard: 'Actions en retard',
    clients_total: 'Clients total',
    non_assignes: 'non assignés',
    quick_actions: 'Actions rapides',
    dispatch_clients: 'Dispatch clients',
    objectifs_kpis: 'Objectifs & KPIs',
    plannings: 'Plannings',
    rapports: 'Rapports',
    my_commerciaux: 'Mes commerciaux',
    recent_visites: 'Visites récentes',
    alert_non_assignes: 'client(s) non assigné(s)',
    assign_click: 'Cliquez pour assigner aux commerciaux',

    // DASHBOARD COMMERCIAL
    dashboard_commercial: 'Dashboard Commercial',
    my_clients: 'Mes clients',
    my_visites: 'Mes visites',
    my_actions: 'Mes actions',
    my_planning: 'Mon planning',
    my_profile: 'Mon profil',
    new_visite: 'Nouvelle visite',
    new_client: 'Nouveau client',
    visite_today: "Visite(s) aujourd'hui",
    score_month: 'Score du mois',
    prime_estimee: 'Prime estimée',
    objectif_visites: 'Objectif visites',
    actions_avenir: 'À venir',
    no_actions: 'Aucune action',
    all_good: 'Tout est à jour !',

    // VISITES
    visite: 'Visite',
    visites: 'Visites',
    date: 'Date',
    client: 'Client',
    resultat: 'Résultat',
    commentaire: 'Commentaire',
    duree: 'Durée',
    prochaine_action: 'Prochaine action',
    no_visite: 'Aucune visite',
    no_visite_mois: 'Aucune visite ce mois',
    visite_7j: 'Visites — 7 derniers jours',

    // CLIENTS
    clients: 'Clients',
    nom: 'Nom',
    telephone: 'Téléphone',
    adresse: 'Adresse',
    commune: 'Commune',
    wilaya: 'Wilaya',
    type: 'Type',
    statut: 'Statut',
    potentiel: 'Potentiel',
    gps: 'Position GPS',
    no_client: 'Aucun client',
    client_info: 'Informations client',
    client_visites: 'Visites client',
    client_actions: 'Actions client',
    client_position: 'Position',

    // ACTIONS
    action: 'Action',
    actions: 'Actions',
    date_action: 'Date prévue',
    statut_action: 'Statut',
    a_faire: 'À faire',
    fait: 'Fait',
    en_retard: 'En retard',
    no_action: 'Aucune action',

    // COMMERCIAUX
    commercial: 'Commercial',
    prenom: 'Prénom',
    nom_label: 'Nom',
    email_label: 'Email',
    mot_de_passe: 'Mot de passe',
    mot_de_passe_min: 'Mot de passe (min. 6 caractères)',
    wilayas: 'Wilayas',
    wilayas_hint: 'Wilayas assignées',
    objectif_visites_mois: 'Objectif visites / mois',
    objectif_clients_mois: 'Objectif nouveaux clients / mois',
    variable_total: 'Variable total DA / mois',
    gestion_commerciaux: 'Gestion Commerciaux',
    add_commercial: 'Ajouter un commercial',
    create_account: 'Créer le compte',
    email_readonly: "L'email ne peut pas être modifié ici.",
    confirm_delete: 'Supprimer',
    confirm_delete_msg: 'Le compte Firestore sera supprimé. Les données associées restent.',
    no_commercial: 'Aucun commercial',
    add_first: 'Ajouter le premier',
    identity: 'Identité',
    connexion_section: 'Connexion',
    objectifs_section: 'Objectifs & Variable',

    // RAPPORTS
    rapports_title: 'Rapports',
    kpis_cles: 'Indicateurs clés',
    performance_comm: 'Performance commerciaux',
    resultats_visites: 'Résultats des visites',
    periode: 'Période',
    semaine: '7 jours',
    mois: 'Ce mois',
    trimestre: 'Trimestre',
    score: 'Score',
    retards: 'Retards',
    export_csv: 'Exporter CSV',
    export_pdf: 'Exporter PDF',
    apercu_csv: 'Aperçu CSV',
    apercu_pdf: 'Aperçu PDF',
    download: 'Télécharger',
    objectif: 'Objectif',

    // PLANNING
    planning_title: 'Planning Semaine',
    planning_submit: 'Soumettre le planning',
    planning_validate: 'Valider',
    planning_refuse: 'Refuser',
    planning_valide: 'Validé',
    planning_refuse_label: 'Refusé',
    planning_attente: 'En attente',
    planning_none: 'Aucun planning',

    // PROFIL
    profil_title: 'Mon Profil',
    prime_mois: 'Prime estimée ce mois',
    base_variable: 'Base variable',
    detail_prime: 'Détail par objectif',

    // NOTIFICATIONS
    notifications: 'Notifications',
    no_notif: 'Aucune notification',
    mark_read: 'Tout marquer comme lu',

    // CARTE
    carte_title: 'Carte Clients',

    // THÈME
    theme_title: 'Choisir un thème',

    // FICHE COMMERCIAL
    fiche_commercial: 'Fiche Commercial',
    modifier_objectifs: 'Modifier les objectifs',
    visites_mois: 'Visites ce mois',
    nouveaux_clients: 'Nouveaux clients',
    clients_assignes: 'Clients assignés',
    visites_mois_liste: 'Visites du mois',
    actions_retard_label: 'Actions en retard',
    detail_prime_obj: 'Détail prime par objectif',

    // FICHE CLIENT
    fiche_client: 'Fiche Client',

    // DISPATCH
    dispatch_title: 'Dispatch Clients',

    // RECHERCHE
    recherche_title: 'Recherche',

    // DÉCONNEXION
    logout: 'Déconnexion',

    // JOURS
    sam: 'Sam', dim: 'Dim', lun: 'Lun', mar: 'Mar', mer: 'Mer', jeu: 'Jeu',

    // FORMULAIRE & AUTRES PAGES
// FORMULAIRE VISITE
    form_visite_title: 'Nouvelle Visite',
    step_client: 'Client',
    step_contact: 'Contact',
    step_resultat: 'Résultat',
    step_action: 'Action',
    step_vocal: 'Note vocale',
    step_recap: 'Récapitulatif',
    choisir_client: 'Choisir un client',
    rechercher_client: 'Rechercher un client...',
    debut_visite: 'Démarrer la visite',
    fin_visite: 'Terminer la visite',
    interlocuteur: 'Interlocuteur',
    fonction: 'Fonction',
    select_resultat: 'Sélectionner un résultat',
    prochaine_action: 'Prochaine action',
    date_relance: 'Date de relance',
    note_vocale: 'Note vocale',
    enregistrer: 'Enregistrer',
    arreter: 'Arrêter',
    ecouter: 'Écouter',
    suivant: 'Suivant',
    precedent: 'Précédent',
    terminer: 'Terminer',
    visite_enregistree: 'Visite enregistrée !',

    // PLANNING
    soumettre_planning: 'Soumettre le planning',
    planning_semaine: 'Planning Semaine',
    ajouter_activite: 'Ajouter une activité',
    valider_planning: 'Valider',
    refuser_planning: 'Refuser',
    motif_refus: 'Motif du refus',
    plannings_attente: 'Plannings en attente',
    mon_planning: 'Mon Planning',
    aucun_planning: 'Aucun planning soumis',

    // FICHE CLIENT
    modifier_client: 'Modifier le client',
    supprimer_client: 'Supprimer le client',
    historique_visites: 'Historique visites',
    actions_client: 'Actions client',
    position_gps: 'Position GPS',
    corriger_gps: 'Corriger la position',
    potentiel_fort: 'Fort',
    potentiel_moyen: 'Moyen',
    potentiel_faible: 'Faible',
    prospect: 'Prospect',
    client_actif: 'Client actif',
    nouveau_client: 'Nouveau client',
    inactif: 'Inactif',

    // PROFIL COMMERCIAL
    mon_profil: 'Mon Profil',
    deconnexion: 'Déconnexion',
    objectifs_mois: 'Objectifs du mois',
    historique_primes: 'Historique des primes',
    mes_wilayas: 'Mes wilayas',

    // NOTIFICATIONS
    notif_planning_soumis: 'Planning soumis',
    notif_planning_valide: 'Planning validé',
    notif_planning_refuse: 'Planning refusé',
    tout_lire: 'Tout marquer comme lu',
    aucune_notif: 'Aucune notification',

    // OBJECTIFS & KPIs
    bibliotheque_objectifs: 'Bibliothèque objectifs',
    ajouter_objectif: 'Ajouter un objectif',
    designation: 'Désignation',
    unite: 'Unité',
    periode: 'Période',
    objectif_cible: 'Objectif cible',
    assigner_objectifs: 'Assigner les objectifs',
    ratio: 'Ratio',
    total_ratio: 'Total ratio',
    sauvegarder_assignation: 'Sauvegarder l\'assignation',

    // DISPATCH CLIENTS
    clients_non_assignes: 'Clients non assignés',
    clients_assignes_comm: 'Clients assignés',
    assigner_a: 'Assigner à',
    retirer: 'Retirer',
    corriger_position: 'Corriger position GPS',
    latitude: 'Latitude',
    longitude: 'Longitude',

    // DASHBOARD PC
    pc_dashboard: 'Dashboard',
    pc_classement: 'Classement',
    pc_visites_recentes: 'Visites récentes',
    pc_actions_retard: 'Actions en retard',
    pc_bonjour: 'Bonjour',
    retard_jours: 'j de retard',
  },

  ar: {
    // GÉNÉRAL
    app_name: 'نشاط تجاري',
    loading: 'جارٍ التحميل...',
    save: 'حفظ',
    cancel: 'إلغاء',
    close: 'إغلاق',
    edit: 'تعديل',
    delete: 'حذف',
    add: 'إضافة',
    confirm: 'تأكيد',
    back: 'رجوع',
    search: 'بحث',
    no_data: 'لا توجد بيانات',
    error: 'خطأ',
    success: 'نجاح',
    yes: 'نعم',
    no: 'لا',
    all: 'الكل',
    total: 'المجموع',
    details: 'التفاصيل',
    refresh: 'تحديث',

    // LOGIN
    login_title: 'تسجيل الدخول',
    login_subtitle: 'إدارة المبيعات الميدانية',
    email: 'البريد الإلكتروني',
    password: 'كلمة المرور',
    login_btn: 'دخول',
    login_error: 'البريد الإلكتروني أو كلمة المرور غير صحيحة',
    login_loading: 'جارٍ الدخول...',

    // DASHBOARD MANAGER
    dashboard_manager: 'لوحة المدير',
    hello: 'مرحباً',
    visites_total: 'إجمالي الزيارات',
    visites_today: 'زيارات اليوم',
    commerciaux: 'المندوبون',
    actions_retard: 'إجراءات متأخرة',
    clients_total: 'إجمالي العملاء',
    non_assignes: 'غير مُعيَّنين',
    quick_actions: 'إجراءات سريعة',
    dispatch_clients: 'توزيع العملاء',
    objectifs_kpis: 'الأهداف والمؤشرات',
    plannings: 'الجداول',
    rapports: 'التقارير',
    my_commerciaux: 'مندوبيّ',
    recent_visites: 'الزيارات الأخيرة',
    alert_non_assignes: 'عميل (عملاء) غير مُعيَّنين',
    assign_click: 'انقر لتعيينهم للمندوبين',

    // DASHBOARD COMMERCIAL
    dashboard_commercial: 'لوحة المندوب',
    my_clients: 'عملائي',
    my_visites: 'زياراتي',
    my_actions: 'إجراءاتي',
    my_planning: 'جدولي',
    my_profile: 'ملفي',
    new_visite: 'زيارة جديدة',
    new_client: 'عميل جديد',
    visite_today: 'زيارة (زيارات) اليوم',
    score_month: 'نقاط الشهر',
    prime_estimee: 'العلاوة المقدّرة',
    objectif_visites: 'هدف الزيارات',
    actions_avenir: 'القادمة',
    no_actions: 'لا إجراءات',
    all_good: 'كل شيء على ما يرام!',

    // VISITES
    visite: 'زيارة',
    visites: 'الزيارات',
    date: 'التاريخ',
    client: 'العميل',
    resultat: 'النتيجة',
    commentaire: 'تعليق',
    duree: 'المدة',
    prochaine_action: 'الإجراء التالي',
    no_visite: 'لا توجد زيارات',
    no_visite_mois: 'لا توجد زيارات هذا الشهر',
    visite_7j: 'الزيارات — آخر 7 أيام',

    // CLIENTS
    clients: 'العملاء',
    nom: 'الاسم',
    telephone: 'الهاتف',
    adresse: 'العنوان',
    commune: 'البلدية',
    wilaya: 'الولاية',
    type: 'النوع',
    statut: 'الحالة',
    potentiel: 'الإمكانية',
    gps: 'الموقع الجغرافي',
    no_client: 'لا يوجد عملاء',
    client_info: 'معلومات العميل',
    client_visites: 'زيارات العميل',
    client_actions: 'إجراءات العميل',
    client_position: 'الموقع',

    // ACTIONS
    action: 'إجراء',
    actions: 'الإجراءات',
    date_action: 'التاريخ المحدد',
    statut_action: 'الحالة',
    a_faire: 'للتنفيذ',
    fait: 'تم',
    en_retard: 'متأخر',
    no_action: 'لا إجراءات',

    // COMMERCIAUX
    commercial: 'مندوب',
    prenom: 'الاسم الأول',
    nom_label: 'اللقب',
    email_label: 'البريد الإلكتروني',
    mot_de_passe: 'كلمة المرور',
    mot_de_passe_min: 'كلمة المرور (6 أحرف على الأقل)',
    wilayas: 'الولايات',
    wilayas_hint: 'الولايات المُعيَّنة',
    objectif_visites_mois: 'هدف الزيارات / شهر',
    objectif_clients_mois: 'هدف العملاء الجدد / شهر',
    variable_total: 'المتغير الإجمالي دج / شهر',
    gestion_commerciaux: 'إدارة المندوبين',
    add_commercial: 'إضافة مندوب',
    create_account: 'إنشاء حساب',
    email_readonly: 'لا يمكن تعديل البريد الإلكتروني هنا.',
    confirm_delete: 'حذف',
    confirm_delete_msg: 'سيتم حذف الحساب. تبقى البيانات المرتبطة.',
    no_commercial: 'لا يوجد مندوبون',
    add_first: 'أضف الأول',
    identity: 'الهوية',
    connexion_section: 'الدخول',
    objectifs_section: 'الأهداف والمتغير',

    // RAPPORTS
    rapports_title: 'التقارير',
    kpis_cles: 'المؤشرات الرئيسية',
    performance_comm: 'أداء المندوبين',
    resultats_visites: 'نتائج الزيارات',
    periode: 'الفترة',
    semaine: '7 أيام',
    mois: 'هذا الشهر',
    trimestre: 'الربع',
    score: 'النقاط',
    retards: 'التأخيرات',
    export_csv: 'تصدير CSV',
    export_pdf: 'تصدير PDF',
    apercu_csv: 'معاينة CSV',
    apercu_pdf: 'معاينة PDF',
    download: 'تحميل',
    objectif: 'الهدف',

    // PLANNING
    planning_title: 'جدول الأسبوع',
    planning_submit: 'إرسال الجدول',
    planning_validate: 'موافقة',
    planning_refuse: 'رفض',
    planning_valide: 'تمت الموافقة',
    planning_refuse_label: 'مرفوض',
    planning_attente: 'في الانتظار',
    planning_none: 'لا يوجد جدول',

    // PROFIL
    profil_title: 'ملفي الشخصي',
    prime_mois: 'العلاوة المقدّرة هذا الشهر',
    base_variable: 'المتغير الأساسي',
    detail_prime: 'تفصيل العلاوة حسب الهدف',

    // NOTIFICATIONS
    notifications: 'الإشعارات',
    no_notif: 'لا توجد إشعارات',
    mark_read: 'تعليم الكل كمقروء',

    // CARTE
    carte_title: 'خريطة العملاء',

    // THÈME
    theme_title: 'اختيار المظهر',

    // FICHE COMMERCIAL
    fiche_commercial: 'ملف المندوب',
    modifier_objectifs: 'تعديل الأهداف',
    visites_mois: 'زيارات الشهر',
    nouveaux_clients: 'عملاء جدد',
    clients_assignes: 'العملاء المُعيَّنون',
    visites_mois_liste: 'زيارات الشهر',
    actions_retard_label: 'إجراءات متأخرة',
    detail_prime_obj: 'تفصيل العلاوة حسب الهدف',

    // FICHE CLIENT
    fiche_client: 'ملف العميل',

    // DISPATCH
    dispatch_title: 'توزيع العملاء',

    // RECHERCHE
    recherche_title: 'بحث',

    // DÉCONNEXION
    logout: 'تسجيل الخروج',

    // JOURS
    sam: 'سبت', dim: 'أحد', lun: 'إثن', mar: 'ثلا', mer: 'أرب', jeu: 'خمي',

    // FORMULAIRE & AUTRES PAGES
// FORMULAIRE VISITE
    form_visite_title: 'Nouvelle Visite',
    step_client: 'Client',
    step_contact: 'Contact',
    step_resultat: 'Résultat',
    step_action: 'Action',
    step_vocal: 'Note vocale',
    step_recap: 'Récapitulatif',
    choisir_client: 'Choisir un client',
    rechercher_client: 'Rechercher un client...',
    debut_visite: 'Démarrer la visite',
    fin_visite: 'Terminer la visite',
    interlocuteur: 'Interlocuteur',
    fonction: 'Fonction',
    select_resultat: 'Sélectionner un résultat',
    prochaine_action: 'Prochaine action',
    date_relance: 'Date de relance',
    note_vocale: 'Note vocale',
    enregistrer: 'Enregistrer',
    arreter: 'Arrêter',
    ecouter: 'Écouter',
    suivant: 'Suivant',
    precedent: 'Précédent',
    terminer: 'Terminer',
    visite_enregistree: 'Visite enregistrée !',

    // PLANNING
    soumettre_planning: 'Soumettre le planning',
    planning_semaine: 'Planning Semaine',
    ajouter_activite: 'Ajouter une activité',
    valider_planning: 'Valider',
    refuser_planning: 'Refuser',
    motif_refus: 'Motif du refus',
    plannings_attente: 'Plannings en attente',
    mon_planning: 'Mon Planning',
    aucun_planning: 'Aucun planning soumis',

    // FICHE CLIENT
    modifier_client: 'Modifier le client',
    supprimer_client: 'Supprimer le client',
    historique_visites: 'Historique visites',
    actions_client: 'Actions client',
    position_gps: 'Position GPS',
    corriger_gps: 'Corriger la position',
    potentiel_fort: 'Fort',
    potentiel_moyen: 'Moyen',
    potentiel_faible: 'Faible',
    prospect: 'Prospect',
    client_actif: 'Client actif',
    nouveau_client: 'Nouveau client',
    inactif: 'Inactif',

    // PROFIL COMMERCIAL
    mon_profil: 'Mon Profil',
    deconnexion: 'Déconnexion',
    objectifs_mois: 'Objectifs du mois',
    historique_primes: 'Historique des primes',
    mes_wilayas: 'Mes wilayas',

    // NOTIFICATIONS
    notif_planning_soumis: 'Planning soumis',
    notif_planning_valide: 'Planning validé',
    notif_planning_refuse: 'Planning refusé',
    tout_lire: 'Tout marquer comme lu',
    aucune_notif: 'Aucune notification',

    // OBJECTIFS & KPIs
    bibliotheque_objectifs: 'Bibliothèque objectifs',
    ajouter_objectif: 'Ajouter un objectif',
    designation: 'Désignation',
    unite: 'Unité',
    periode: 'Période',
    objectif_cible: 'Objectif cible',
    assigner_objectifs: 'Assigner les objectifs',
    ratio: 'Ratio',
    total_ratio: 'Total ratio',
    sauvegarder_assignation: 'Sauvegarder l\'assignation',

    // DISPATCH CLIENTS
    clients_non_assignes: 'Clients non assignés',
    clients_assignes_comm: 'Clients assignés',
    assigner_a: 'Assigner à',
    retirer: 'Retirer',
    corriger_position: 'Corriger position GPS',
    latitude: 'Latitude',
    longitude: 'Longitude',

    // FORMULAIRE & AUTRES PAGES
// FORMULAIRE VISITE
    form_visite_title: 'زيارة جديدة',
    step_client: 'العميل',
    step_contact: 'جهة الاتصال',
    step_resultat: 'النتيجة',
    step_action: 'الإجراء',
    step_vocal: 'ملاحظة صوتية',
    step_recap: 'ملخص',
    choisir_client: 'اختر عميلاً',
    rechercher_client: 'ابحث عن عميل...',
    debut_visite: 'بدء الزيارة',
    fin_visite: 'إنهاء الزيارة',
    interlocuteur: 'المحاور',
    fonction: 'الوظيفة',
    select_resultat: 'اختر النتيجة',
    prochaine_action: 'الإجراء التالي',
    date_relance: 'تاريخ المتابعة',
    note_vocale: 'ملاحظة صوتية',
    enregistrer: 'تسجيل',
    arreter: 'إيقاف',
    ecouter: 'استماع',
    suivant: 'التالي',
    precedent: 'السابق',
    terminer: 'إنهاء',
    visite_enregistree: 'تم حفظ الزيارة!',

    // PLANNING
    soumettre_planning: 'إرسال الجدول',
    planning_semaine: 'جدول الأسبوع',
    ajouter_activite: 'إضافة نشاط',
    valider_planning: 'موافقة',
    refuser_planning: 'رفض',
    motif_refus: 'سبب الرفض',
    plannings_attente: 'الجداول قيد الانتظار',
    mon_planning: 'جدولي',
    aucun_planning: 'لم يُرسل أي جدول',

    // FICHE CLIENT
    modifier_client: 'تعديل العميل',
    supprimer_client: 'حذف العميل',
    historique_visites: 'سجل الزيارات',
    actions_client: 'إجراءات العميل',
    position_gps: 'الموقع الجغرافي',
    corriger_gps: 'تصحيح الموقع',
    potentiel_fort: 'قوي',
    potentiel_moyen: 'متوسط',
    potentiel_faible: 'ضعيف',
    prospect: 'عميل محتمل',
    client_actif: 'عميل نشط',
    nouveau_client: 'عميل جديد',
    inactif: 'غير نشط',

    // PROFIL COMMERCIAL
    mon_profil: 'ملفي الشخصي',
    deconnexion: 'تسجيل الخروج',
    objectifs_mois: 'أهداف الشهر',
    historique_primes: 'سجل العلاوات',
    mes_wilayas: 'ولاياتي',

    // NOTIFICATIONS
    notif_planning_soumis: 'تم إرسال الجدول',
    notif_planning_valide: 'تمت الموافقة على الجدول',
    notif_planning_refuse: 'تم رفض الجدول',
    tout_lire: 'تعليم الكل كمقروء',
    aucune_notif: 'لا توجد إشعارات',

    // OBJECTIFS & KPIs
    bibliotheque_objectifs: 'مكتبة الأهداف',
    ajouter_objectif: 'إضافة هدف',
    designation: 'التسمية',
    unite: 'الوحدة',
    periode: 'الفترة',
    objectif_cible: 'الهدف المستهدف',
    assigner_objectifs: 'تعيين الأهداف',
    ratio: 'النسبة',
    total_ratio: 'مجموع النسب',
    sauvegarder_assignation: 'حفظ التعيين',

    // DISPATCH CLIENTS
    clients_non_assignes: 'عملاء غير مُعيَّنين',
    clients_assignes_comm: 'العملاء المُعيَّنون',
    assigner_a: 'تعيين إلى',
    retirer: 'إزالة',
    corriger_position: 'تصحيح الموقع الجغرافي',
    latitude: 'خط العرض',
    longitude: 'خط الطول',

    // DASHBOARD PC
    pc_dashboard: 'لوحة التحكم',
    pc_classement: 'الترتيب',
    pc_visites_recentes: 'آخر الزيارات',
    pc_actions_retard: 'الإجراءات المتأخرة',
    pc_bonjour: 'مرحباً',
    retard_jours: 'يوم تأخير',
  }
};

export function t(lang, key, fallback) {
  return translations[lang]?.[key] || translations['fr']?.[key] || fallback || key;
}
